module.exports = __webpack_public_path__ + "static/img/ludek_angry.e3401216.png";